import "./TitlePrivilegeTable.scss";

export default function TitlePrivilegeTable({
  titlePrivilege,
  detailPrivilege,
  detailPrivilegeMonth,
  hrefPrivilege,
  backgroundColor,
  color,
  textButton = "Me interesa",
}) {
  return (
    <div className="BoxTablePrivilege">
      <h2 className="TitleTablePrivilege">{titlePrivilege}</h2>
      <div className="CostPrivilege">
        <p className="DetailTablePrivilege">{detailPrivilege}</p>
        <p className="DetailTablePrivilege">{detailPrivilegeMonth}</p>
      </div>

      <a
        className="ButtonTablePrivilege"
        href={hrefPrivilege}
        style={{ backgroundColor, color }}
      >
        {textButton}
      </a>
    </div>
  );
}
